import React from 'react';
import { Section } from './Shared';
const VIDEO_SRC = 'https://cdn.magicpatterns.com/uploads/acisEBZuA3iYHREWHbT57K/Scroll_Qigong_Optimizado_Magic_Partners.mp4';
export const VideoPreview = () => <Section className="max-w-4xl py-10 md:py-14" data-id="element-263" data-mp="36tlcos2s9itg">
    <div className="mb-6 text-center md:mb-8" data-id="element-264" data-mp="36ss7vwndx3dy">
      <h2 className="mx-auto max-w-[24ch] font-display text-2xl font-bold uppercase leading-[1.12] tracking-[0.06em] text-brand-burgundy md:text-4xl lg:text-[44px]" data-id="element-265" data-mp="3blczcritj4eb">
        Take a Look Inside the Qigong Mastery Bundle
      </h2>
      <span aria-hidden="true" className="ink-rule mx-auto mt-4 w-16 md:w-24" data-id="element-266" data-mp="3lhok85wh52kd" />
    </div>

    <div className="paper-panel overflow-hidden rounded-2xl p-2 md:p-3" data-id="element-267" data-mp="3plw860v3yehj">
      <video src={VIDEO_SRC} autoPlay loop muted playsInline aria-label="Page-by-page preview of the Qigong Mastery Bundle volumes and bonuses" className="h-auto w-full rounded-sm object-cover" data-id="element-268" data-mp="3uk7g261ueex4" />
    </div>
  </Section>;